var React = require('react');

function YoutubePlay (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_454","data-name":"Ellipse 454","cx":"32","cy":"32","r":"32","fill":"#e35205","opacity":"0.74","key":0}),React.createElement("path",{"id":"Polygon_5","data-name":"Polygon 5","d":"M12.5,0,25,16H0Z","transform":"translate(42.553 19) rotate(90)","fill":"#fff","key":1})]);
}

YoutubePlay.defaultProps = {"id":"Component_282","data-name":"Component 282","width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = YoutubePlay;

YoutubePlay.default = YoutubePlay;
